import InfoForm from './InfoForm';
import { Messages } from './Messages';

const PersonalInfo = (props) => (
  <>
    <Messages />
    <InfoForm {...props} />
  </>
);

export default PersonalInfo;
